module.exports = __webpack_public_path__ + "static/media/mars.f902dbfa.jpg";